export default "__VITE_PUBLIC_ASSET__71add250__"